import { Edit, SimpleForm, TextInput, BooleanInput, NumberInput, SelectInput } from 'react-admin';

export const SettingsEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="setting_name" fullWidth />
      <NumberInput source="daily_ad_target" />
      <NumberInput source="share_boost_user_target" />
      <NumberInput source="daily_user_ad_limit" />

      <NumberInput source="base_rev_share" />
      <NumberInput source="share_boost_rev_share" />

      <NumberInput source="token_usd_rate" />
      <NumberInput source="minimum_usd_withdrawal_balance" />
      <NumberInput source="fixed_transaction_fee" />
      <NumberInput source="variable_transaction_fee_percentage" />
      <NumberInput source="paypal_fee_fixed" />
      <NumberInput source="paypal_fee_percentage" />
      <NumberInput source="referree_signup_bonus" />

      <TextInput source="app_share_link" fullWidth />

      <SelectInput source="mediation_provider" choices={[
        { id: 'admob', name: 'Google AdMob' },
        { id: 'levelplay', name: 'Unity LevelPlay' },
      ]} />
      <TextInput source="android_rewarded_ad_unit" fullWidth />
      <TextInput source="ios_rewarded_ad_unit" fullWidth />
      <TextInput source="ironsource_android_app_key" fullWidth />
      <TextInput source="ironsource_ios_app_key" fullWidth />

      <BooleanInput source="ad_server_offline" />
      <TextInput source="ad_server_offline_message" fullWidth multiline rows={4} />
      
      <BooleanInput source="show_system_alert" />
      <TextInput source="system_alert_title" fullWidth />
      <TextInput source="system_alert_message" fullWidth multiline rows={4} />
      <TextInput source="system_alert_button_label" fullWidth />

    </SimpleForm>
  </Edit>
);